'use client';

import { Button, Label, Modal, ModalBody, ModalHeader, TextInput } from 'flowbite-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { toastError } from '../../components/Toast.tsx';
import { useCreateBuildingMutation } from '../../lib/model/kantoordagApi.ts';

interface CreateBuildingDialogProps {
    show: boolean;
    onClose: () => void;
    onCreated: (buildingName: string) => void;
}

export default function CreateBuildingDialog({ show, onClose, onCreated }: CreateBuildingDialogProps) {
    const { t } = useTranslation('building-admin');
    const [name, setName] = useState('');
    const [createBuilding, createBuildingResult] = useCreateBuildingMutation();

    function close() {
        setName('');
        onClose();
    }

    function submit() {
        const trimmed = name.trim();
        if (trimmed === '') {
            return;
        }
        createBuilding({ building: trimmed })
            .unwrap()
            .then(() => {
                toast.success(t('building_created'));
                onCreated(trimmed);
                close();
            })
            .catch(() => toastError({ api: createBuildingResult, message: t('building_create_failed') }));
    }

    return (
        <Modal show={show} size="md" onClose={close} popup>
            <ModalHeader>{t('create_building')}</ModalHeader>
            <ModalBody>
                <div data-testid="create-building-dialog" className="flex flex-col gap-4">
                    <div>
                        <Label htmlFor="new-building-name">{t('new_building_name')}</Label>
                        <TextInput
                            id="new-building-name"
                            value={name}
                            onChange={event => setName(event.target.value)}
                        />
                    </div>
                    <div className="flex justify-end gap-2">
                        <Button color="secondary" onClick={close}>{t('cancel')}</Button>
                        <Button onClick={submit}>{t('create_building')}</Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
}
